module.exports = __webpack_public_path__ + "static/bushido_icon-5855244e6e495d0701ae19af994ee3a6.gif";